import { getLocale, isBrowsingInternationalShop, localesThatUseIPForPrices } from '@libs/constants';
import { isPotentialMyIgusUser } from '@libs/myigus';
import { useRouter } from 'next/router';
import { Locale } from '@formatjs/intl-locale';
import { useSessionStore } from '@hooks/states/useSessionStore';
import * as Sentry from '@sentry/nextjs';

export const useHasDynamicPrice = (): boolean => {
  const router = useRouter();
  const session = useSessionStore(state => state.session);
  // we only want to use dynamic prices when running in client
  if (typeof window === 'undefined' || typeof window?.location === 'undefined') {
    return false;
  }

  if (isPotentialMyIgusUser()) {
    return true;
  }

  const locale = getLocale(router);

  const { region } = new Locale(locale);

  // on the .eu TLD we always want to show dynamic prices
  if (isBrowsingInternationalShop()) {
    return true;
  }

  // there should not be another domain beside .eu without a region set in its locale
  if (!region) {
    const hostname =
      typeof window !== 'undefined' && typeof window?.location !== 'undefined' ? window.location.hostname : 'n.a.';
    Sentry.captureException(
      `No region is set in the locale operating on a non igus.eu domain. Locale: '${locale}', Hostname: '${hostname}'`
    );
    return true;
  }

  if (!localesThatUseIPForPrices.includes(locale)) {
    return false;
  }

  return !!(session && session.priceCountry.toUpperCase() !== region.toUpperCase());
};
